var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _rect2, _path10, _rect3, _path11, _rect4, _path12, _rect5, _path13, _rect6, _path14, _rect7, _path15, _rect8, _path16, _rect9, _path17, _rect10, _path18, _rect11, _path19, _rect12, _rect13, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeroHomeXl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2725,
    height: 681,
    viewBox: "0 0 2725 681",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1342,
    cy: 244,
    r: 150,
    fill: "#D2B487"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 254.754C0 254.754 200.559 182.253 502.422 207.308C745.59 227.491 739.116 245.16 1040.8 254.754C1280.86 262.389 2032.4 201 2254.75 201C2477.1 201 2725 254.754 2725 254.754V681H0V254.754Z",
    fill: "#F2EBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 428.456C0 428.456 436.405 399.373 747.483 399.591C1053.02 399.805 1150.56 457.979 1479.83 428.456C1690.12 409.601 2145.94 392.64 2285.97 399.591C2426.01 406.542 2725 428.456 2725 428.456V681H0V428.456Z",
    fill: "#E4D7C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2015.5 400.556C2033.01 400.556 2033.5 400.556 2067 400.556C1881.5 413.444 1820.5 681 1820.5 681H1662C1662 681 1849 400.556 2015.5 400.556Z",
    fill: "#F2EBDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2183.55 347.462C2183.55 346.079 2182.6 344.875 2181.26 344.547L2094.78 323.434C2094.44 323.35 2094.11 323.205 2093.82 323.007L2040.64 287.157C2039.24 286.209 2037.33 286.614 2036.42 288.051L2004.96 338.237C2004.66 338.715 2004.5 339.267 2004.5 339.831V398.402C2004.5 400.059 2005.84 401.402 2007.5 401.402H2180.55C2182.2 401.402 2183.55 400.059 2183.55 398.402V347.462Z",
    fill: "#C08A8A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2183.88 347.666C2183.88 346.267 2182.91 345.054 2181.55 344.741L2095.17 324.952C2093.29 324.522 2091.5 325.949 2091.5 327.876V398.571C2091.5 400.228 2092.84 401.571 2094.5 401.571H2180.88C2182.54 401.571 2183.88 400.228 2183.88 398.571V347.666Z",
    fill: "#B57878"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2133.01 313.111C2132.94 313.066 2132.86 313.032 2132.77 313.008L2039.8 286.777C2038.7 286.466 2038.02 287.951 2038.98 288.577L2094.78 324.997C2094.87 325.061 2094.98 325.107 2095.1 325.134L2184.22 345.769C2185.34 346.027 2185.94 344.518 2184.96 343.935L2133.01 313.111Z",
    fill: "#E4D7C7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2725 574.289C2725 574.289 2229.2 533.07 1977.52 558.458C1699.12 586.542 1625.58 563.561 1285.86 566.596C937.665 569.707 695.443 544 472.144 544C248.845 544 -7.62939e-05 574.289 -7.62939e-05 574.289V681H2725V574.289Z",
    fill: "#E2DCD8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M337 136.215H353.216L350.189 81.0804H340.027L337 136.215Z",
    fill: "#6D6363"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.24321,
    height: 29.1889,
    transform: "matrix(1 0 0 -1 343.595 92.7559)",
    fill: "#6D6363"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M353.215 0H336.999L340.026 55.1346H350.188L353.215 0Z",
    fill: "#6D6363"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.24321,
    height: 29.1889,
    transform: "matrix(-1 0 0 1 346.729 42.1619)",
    fill: "#6D6363"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M277 76.2155V59.9994L332.135 63.0264V73.1885L277 76.2155Z",
    fill: "#6D6363"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 320.459,
    y: 69.621,
    width: 3.24321,
    height: 29.1889,
    transform: "rotate(-90 320.459 69.621)",
    fill: "#6D6363"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M413.215 59.9994V76.2155L358.08 73.1885V63.0264L413.215 59.9994Z",
    fill: "#6D6363"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 371.054,
    y: 66.4859,
    width: 3.24321,
    height: 29.1889,
    transform: "rotate(90 371.054 66.4859)",
    fill: "#6D6363"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M400.036 109.183L408.144 95.1398L358.883 70.1939L353.802 78.9945L400.036 109.183Z",
    fill: "#6D6363"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.24321,
    height: 29.1889,
    transform: "matrix(0.5 -0.866025 -0.866025 -0.5 365.696 81.7429)",
    fill: "#6D6363"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M290.178 27.0322L282.07 41.0757L331.331 66.0216L336.412 57.2209L290.178 27.0322Z",
    fill: "#6D6363"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.24321,
    height: 29.1889,
    transform: "matrix(-0.5 0.866025 0.866025 0.5 323.448 53.7305)",
    fill: "#6D6363"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M290.178 109.183L282.07 95.1398L331.332 70.1939L336.413 78.9945L290.178 109.183Z",
    fill: "#6D6363"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 324.518,
    y: 81.7429,
    width: 3.24321,
    height: 29.1889,
    transform: "rotate(-120 324.518 81.7429)",
    fill: "#6D6363"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M400.037 27.0322L408.145 41.0757L358.883 66.0216L353.802 57.2209L400.037 27.0322Z",
    fill: "#6D6363"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 366.766,
    y: 53.7305,
    width: 3.24321,
    height: 29.1889,
    transform: "rotate(60 366.766 53.7305)",
    fill: "#6D6363"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M372.139 131.145L386.183 123.037L355.994 76.8021L347.193 81.8831L372.139 131.145Z",
    fill: "#6D6363"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 3.24321,
    height: 29.1889,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 356.121 90.2109)",
    fill: "#6D6363"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M318.075 5.07068L304.031 13.1787L334.22 59.4132L343.021 54.3322L318.075 5.07068Z",
    fill: "#6D6363"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.24321,
    height: 29.1889,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 333.538 44.8273)",
    fill: "#6D6363"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M318.075 131.145L304.032 123.037L334.22 76.8021L343.021 81.8831L318.075 131.145Z",
    fill: "#6D6363"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 334.094,
    y: 90.2109,
    width: 3.24321,
    height: 29.1889,
    transform: "rotate(-150 334.094 90.2109)",
    fill: "#6D6363"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M372.14 5.07068L386.183 13.1787L355.994 59.4132L347.194 54.3322L372.14 5.07068Z",
    fill: "#6D6363"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 356.676,
    y: 44.8273,
    width: 3.24321,
    height: 29.1889,
    transform: "rotate(30 356.676 44.8273)",
    fill: "#6D6363"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 343.772,
    y: 66.772,
    width: 96.1518,
    height: 2.67088,
    fill: "#6D6363"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M434.583 53.4176L488 48.0758L478.652 64.1011L488 81.4618L434.583 77.4555V53.4176Z",
    fill: "#6D6363"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M345.107 244.386V205.658M345.107 205.658L295.383 242.632C294.617 243.202 293.564 242.477 293.824 241.558L310.386 182.956M345.107 205.658L379.829 182.956M345.107 205.658V158.918M345.107 205.658L310.386 182.956M310.386 182.956L397.429 242.717C398.217 243.258 399.242 242.491 398.946 241.583L379.829 182.956M310.386 182.956L323.74 140.221M310.386 182.956L345.107 158.918M310.386 182.956H379.829M379.829 182.956L345.107 158.918M379.829 182.956L366.474 140.221M323.74 140.221L345.107 158.918M323.74 140.221L332.675 109.506M323.74 140.221L357.539 109.506M345.107 158.918L366.474 140.221M345.107 158.918V66.7722M366.474 140.221L332.675 109.506M366.474 140.221L357.539 109.506M345.107 66.7722L332.675 109.506M345.107 66.7722L357.539 109.506",
    stroke: "#6D6363"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroHomeXl);
export default __webpack_public_path__ + "static/media/hero-home-xl.435e8d37.svg";
export { ForwardRef as ReactComponent };